// extracted by mini-css-extract-plugin
export default {"container":"UserImage_container__RsOV0"};